import { FormProps } from './interface/form-props.interface';

export interface CreateCustomerDTO {
  organizationName: string;
  address: string;
  state: string;
  country: string;
  companyLogoUrl: string;
  phoneNumber: string;
  createdBy?: { id: string };
}

export class CreateCustomerFormData {
  [key: string]: FormProps;

  organizationName: FormProps = {
    name: 'organizationName',
    label: 'Organization Name',
    type: 'text',
    placeholder: 'Organization Name',
    required: true
  };
  address: FormProps = {
    name: 'address',
    label: 'Address',
    type: 'text',
    placeholder: 'Address',
    required: true
  };
  state: FormProps = {
    name: 'state',
    label: 'State',
    type: 'text',
    placeholder: 'State',
    required: true
  };
  country: FormProps = {
    name: 'country',
    label: 'Country',
    type: 'text',
    placeholder: 'Country',
    required: true
  };
  companyLogoUrl: FormProps = {
    name: 'companyLogoUrl',
    label: 'Company Logo Url',
    type: 'text',
    placeholder: 'Company Logo Url',
    required: false
  };
  phoneNumber: FormProps = {
    name: 'phoneNumber',
    label: 'Phone Number',
    type: 'tel',
    placeholder: '555-555-5555',
    required: true
  };
}
